import React, { useEffect, useState } from "react";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import materialProduto from "../../enums/materialProduto";

import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  TextField,
  // makeStyles,
} from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

export default function Catalogo({ history }) {
  const classes = useStyles();

  const [carregando, setCarregando] = useState(true);
  const [comboCategoria, setComboCategoria] = useState([]);
  const [filtros, setFiltros] = useState({
    nome: "",
    categoriaId: 0,
    produtoPerto: 0,
  });
  const [catalogo, setCatalogo] = useState([]);

  useEffect(() => {
    carregarComboCategoria();
    carregarCatalogo();
  }, []);

  const carregarComboCategoria = () => {
    api
      .get("produtos/listarCategorias")
      .then((comboCategoria) => setComboCategoria(comboCategoria))
      .catch((e) => alert("Erro: " + e));
  };

  const carregarCatalogo = () => {
    api
      .get("produtos/catalogo", { filtros })
      .then((catalogo) => {
        setCatalogo(catalogo);
        setCarregando(false);
      })
      .catch((e) => alert("Erro ao carregar o catalago" + e));
  };

  const selecionarProdutoPerto = (produtoPerto) => {
    const filtrosAtualizar = { ...filtros };

    filtrosAtualizar.produtoPerto = produtoPerto;

    setFiltros(filtrosAtualizar);
  };

  const selecionarCategoria = (categoriaId) => {
    const filtrosAtualizar = { ...filtros };

    filtrosAtualizar.categoriaId = categoriaId;

    setFiltros(filtrosAtualizar);
  };

  const preencherFiltroNome = (nome) => {
    const filtrosAtualizar = { ...filtros };

    filtrosAtualizar.nome = nome;

    setFiltros(filtrosAtualizar);
  };

  const abrirProduto = (produtoId) => {
    history.push(`/app/catalogo/produto/${produtoId}`);
  };

  return (
    <div className="main-container">
      <Grid container direction="row" justifyContent="end" alignItems="center">
        {/* <h1>Catalogo</h1> */}
        <Button
          variant="contained"
          color="primary"
          startIcon={<ShoppingCart />}
          onClick={() => history.push("/app/carrinho")}
        >
          Meu carrinho
        </Button>
      </Grid>
      <br />

      {carregando ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={2} justifyContent="center">
          <Grid item md={3}>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filtros.produtoPerto}
              onChange={(e) => selecionarProdutoPerto(e.target.value)}
            >
              <MenuItem key={0} value={0}>
                (Todos os produtos Perto)
              </MenuItem>
              {Object.entries(materialProduto)
                .filter((e) => e[0] !== "desc")
                .map((entry, key) => (
                  <MenuItem key={key} value={entry[1]}>
                    {materialProduto.desc(entry[1])}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
          <br />

          <Grid item md={3}>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filtros.categoriaId}
              onChange={(e) => selecionarCategoria(e.target.value)}
            >
              <MenuItem key={0} value={0}>
                (Todas as categorias)
              </MenuItem>
              {comboCategoria.map((item, key) => (
                <MenuItem key={key} value={item.id}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <br />

          <Grid item md={3}>
            <TextField
              className="main-input"
              fullWidth
              id="standard-search"
              label="Buscar produto"
              type="search"
              value={filtros.noem}
              onChange={(e) => preencherFiltroNome(e.target.value)}
            />
          </Grid>
          <br />

          <Grid item md={1} style={{ marginTop: "auto" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={carregarCatalogo}
            >
              Buscar
            </Button>
          </Grid>
        </Grid>
      )}

      <br />

      <Grid justifyContent="center" container>
        <Grid item md={9} sm={9}>
          <Grid container>
            {catalogo.map((produto, key) => (
              <Grid md={4} sm={4}>
                <Card style={{ margin: "15px" }}>
                  <CardActionArea onClick={() => abrirProduto(produto.id)}>
                    <CardMedia
                      className={classes.media}
                      image={
                        produto.imagemPrincipal
                          ? `${serverHost()}/${produto.imagemPrincipal}`
                          : ""
                      }
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <h5 style={{ fontWeight: "bolder" }}>{produto.nome}</h5>
                      <br />
                      <h6>R$ {produto.valorVenda / 100}</h6>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 300,
    backgroundSize: "contain",
  },
  price: {
    fontWeight: "bolder",
  },
});
